(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
document.querySelectorAll('[data-brand-directory]').forEach(directory=>{const input=directory.querySelector('[data-brand-search]'),clear=directory.querySelector('[data-brand-clear]'),cards=[...directory.querySelectorAll('[data-brand-card]')],groups=[...directory.querySelectorAll('[data-brand-group]')],visible=directory.querySelector('[data-brand-visible]'),empty=directory.querySelector('[data-brand-empty]');const update=()=>{const query=input.value.trim().toLowerCase();let count=0;cards.forEach(card=>{const show=card.dataset.brandTitle.includes(query);card.hidden=!show;if(show)count++;});groups.forEach(group=>{group.hidden=!group.querySelector('[data-brand-card]:not([hidden])');});visible.textContent=count;empty.hidden=count!==0;clear.hidden=!query;};input.addEventListener('input',update);clear.addEventListener('click',()=>{input.value='';input.focus();update();});directory.querySelector('[data-brand-reset]').addEventListener('click',()=>{input.value='';update();input.focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odu-order-catalog"] && !Shopify.designMode) return;
  try {
    
(() => {
const root=document.querySelector('.odu-order');if(!root)return;
const inputs=[...root.querySelectorAll('[data-order-id]')],buttons=[...root.querySelectorAll('[data-order-add]')],statuses=[...root.querySelectorAll('[data-order-status]')],floating=root.querySelector('.odu-order-summary--floating'),dialog=root.querySelector('[data-selection-dialog]');
const key='odu-order-selections-v1:'+root.dataset.member;let saved={},busy=false,uncertain=false,cartQuantities={};
try{const raw=JSON.parse(sessionStorage.getItem(key)||'{}');for(const [id,item] of Object.entries(raw)){if(/^\d+$/.test(id)&&Number.isInteger(item.quantity)&&item.quantity>0&&typeof item.title==='string'&&typeof item.url==='string'&&item.url.startsWith('/products/'))saved[id]=item;}}catch(e){}
const persist=()=>{try{sessionStorage.setItem(key,JSON.stringify(saved));}catch(e){}};const paintRowCartStatus=()=>inputs.forEach(input=>{const qty=cartQuantities[input.dataset.orderId]||0,status=input.closest('article').querySelector('[data-row-cart-status]');if(status)status.textContent=qty>0?'In-cart qty '+qty:'';});const rememberCart=cart=>{cartQuantities={};if(cart&&Array.isArray(cart.items))cart.items.forEach(item=>cartQuantities[String(item.variant_id)]=item.quantity);paintRowCartStatus();};
const setStatus=text=>statuses.forEach(el=>el.textContent=text);
const remember=i=>{const quantity=Number(i.value),id=i.dataset.orderId,row=i.closest('article');if(quantity>0&&Number.isInteger(quantity)&&i.checkValidity())saved[id]={quantity,title:row.querySelector('h2').textContent.trim(),url:row.querySelector('.odu-order-photo').getAttribute('href')};else if(quantity===0)delete saved[id];persist();};
inputs.forEach(i=>{const entry=saved[i.dataset.orderId];if(entry){i.value=Math.min(entry.quantity,i.max?Number(i.max):entry.quantity);remember(i);}});
const update=()=>{const count=Object.values(saved).reduce((n,i)=>n+i.quantity,0),valid=inputs.every(i=>i.checkValidity());root.querySelectorAll('[data-order-count]').forEach(el=>el.textContent=count+' frame'+(count===1?'':'s')+' selected');root.querySelector('[data-order-next]').textContent='Your selections stay with you while you browse brands and filters.';buttons.forEach(button=>button.disabled=busy||uncertain||!valid||count===0);root.querySelectorAll('[data-row-add]').forEach(button=>{const input=button.closest('.odu-order-price').querySelector('[data-order-id]');button.disabled=busy||uncertain||!input.checkValidity()||Number(input.value)<=0;});floating.hidden=count===0&&!busy&&!uncertain;root.querySelectorAll('[data-review-selections]').forEach(button=>button.disabled=busy||count===0);};
const renderReview=()=>{const list=dialog.querySelector('[data-selection-list]');list.replaceChildren();for(const [id,item] of Object.entries(saved)){const row=document.createElement('li'),link=document.createElement('a'),qty=document.createElement('span'),remove=document.createElement('button');link.href=item.url;link.textContent=item.title;qty.textContent='Quantity: '+item.quantity;remove.type='button';remove.textContent='Remove';remove.setAttribute('aria-label','Remove '+item.title);remove.addEventListener('click',()=>{delete saved[id];const input=inputs.find(i=>i.dataset.orderId===id);if(input)input.value=0;persist();update();renderReview();});row.append(link,qty,remove);list.append(row);}if(!list.children.length)list.textContent='No frames selected yet.';};
root.querySelectorAll('[data-review-selections]').forEach(button=>button.addEventListener('click',()=>{renderReview();dialog.showModal();}));dialog.querySelector('[data-close-selections]').addEventListener('click',()=>dialog.close());
inputs.forEach(i=>i.addEventListener('input',()=>{remember(i);update();}));
root.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>{if(busy||uncertain)return;const i=button.parentElement.querySelector('input'),max=i.max?Number(i.max):Infinity;i.value=Math.max(0,Math.min(max,(Number(i.value)||0)+Number(button.dataset.step)));remember(i);update();}));
const receiptKey='odu-order-receipt';try{const receipt=sessionStorage.getItem(receiptKey);if(receipt){setStatus(receipt);sessionStorage.removeItem(receiptKey);}}catch(e){}
const add=async(ids)=>{if(busy||uncertain||!ids.length)return;if(inputs.some(i=>!i.reportValidity()))return;if(ids.length>250){setStatus('Please add no more than 250 different frames at a time. Use Review selections to adjust your list.');return;}const items=ids.map(id=>({id,quantity:saved[id].quantity}));busy=true;update();root.querySelectorAll('[data-step],[data-row-add]').forEach(button=>button.disabled=true);inputs.forEach(i=>i.disabled=true);setStatus('Adding your selected frames…');try{const response=await fetch(root.dataset.add,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items,sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})});if(!response.ok)throw new Error('Addition not confirmed');const result=await response.json();const cartDrawer=document.querySelector('cart-drawer');if(cartDrawer&&result.sections&&typeof cartDrawer.renderContents==='function')cartDrawer.renderContents(result);ids.forEach(id=>{delete saved[id];const input=inputs.find(i=>i.dataset.orderId===id);if(input)input.value=0;});persist();try{sessionStorage.setItem(receiptKey,items.reduce((n,i)=>n+i.quantity,0)+' frame'+(items.reduce((n,i)=>n+i.quantity,0)===1?'':'s')+' added. Continue shopping.');}catch(e){}const addedCount=items.reduce((n,item)=>n+item.quantity,0);const cartResponse=await fetch(root.dataset.cart+'.js',{headers:{Accept:'application/json'},cache:'no-store'});const cart=cartResponse.ok?await cartResponse.json():null;busy=false;uncertain=false;root.querySelectorAll('[data-step],[data-row-add]').forEach(button=>button.disabled=false);inputs.forEach(input=>input.disabled=false);if(cart){rememberCart(cart);const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble');if(bubble){const visible=bubble.querySelector('[aria-hidden="true"]');const accessible=bubble.querySelector('.visually-hidden');if(visible)visible.textContent=cart.item_count;if(accessible)accessible.textContent=cart.item_count+' items';}}setStatus(addedCount+' frame'+(addedCount===1?'':'s')+' added to your cart.');document.dispatchEvent(new CustomEvent('odu:cart-updated',{detail:{cart}}));update();}catch(e){busy=false;uncertain=false;root.querySelectorAll('[data-step],[data-row-add]').forEach(button=>button.disabled=false);inputs.forEach(input=>input.disabled=false);setStatus('We could not confirm the full addition. Review your cart before retrying; availability may have changed.');update();floating.querySelector('a[href]').focus();}};
buttons.forEach(button=>button.addEventListener('click',()=>{if(!button.disabled)add(Object.keys(saved));}));root.querySelectorAll('[data-row-add]').forEach(button=>button.addEventListener('click',()=>{const i=button.closest('.odu-order-price').querySelector('[data-order-id]');if(Number(i.value)<=0)return;remember(i);update();add([i.dataset.orderId]);}));update();fetch(root.dataset.cart+'.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(response=>response.ok?response.json():null).then(cart=>{if(cart)rememberCart(cart);}).catch(()=>{});
const listsKey='odu-shopping-lists-v1:'+root.dataset.member;
let lists=[];try{const raw=JSON.parse(localStorage.getItem(listsKey)||'[]');if(Array.isArray(raw))lists=raw.filter(l=>l&&typeof l.id==='string'&&typeof l.name==='string'&&Array.isArray(l.items)).slice(0,20);}catch(e){}
const listsButton=document.createElement('button');listsButton.type='button';listsButton.className='odu-selection-review';listsButton.textContent='Saved lists';root.querySelector('.odu-order-summary--top').append(listsButton);
const listsPanel=document.createElement('section');listsPanel.className='odu-saved-lists';listsPanel.innerHTML='<h3>Saved shopping lists</h3><p>Save favorite frames for your next order. Lists are stored only in this browser on this device.</p><form><label for="odu-list-name">List name</label><input id="odu-list-name" name="list-name" maxlength="60" required placeholder="e.g. Optical restock"><button type="submit">Save selected frames</button></form><p role="status" data-list-status></p><ul data-saved-lists></ul>';
dialog.append(listsPanel);const listStatus=listsPanel.querySelector('[data-list-status]');
const writeLists=()=>{try{localStorage.setItem(listsKey,JSON.stringify(lists));return true;}catch(e){listStatus.textContent='This browser could not save the list. Your current selections are still available.';return false;}};
const paintLists=()=>{const container=listsPanel.querySelector('[data-saved-lists]');container.replaceChildren();for(const list of lists){const row=document.createElement('li'),title=document.createElement('strong'),load=document.createElement('button'),remove=document.createElement('button');title.textContent=list.name;load.type=remove.type='button';load.textContent='Add to selections';remove.textContent='Delete list';load.setAttribute('aria-label','Add '+list.name+' to selections');remove.setAttribute('aria-label','Delete list '+list.name);load.addEventListener('click',()=>{for(const item of list.items){if(!item||!/^\d+$/.test(item.id)||!Number.isInteger(item.quantity)||item.quantity<1||typeof item.title!=='string'||typeof item.url!=='string'||!item.url.startsWith('/products/'))continue;saved[item.id]={title:item.title,url:item.url,quantity:Math.max(item.quantity,saved[item.id]?.quantity||0)};}inputs.forEach(i=>{const item=saved[i.dataset.orderId];if(item){i.value=Math.min(item.quantity,i.max?Number(i.max):item.quantity);remember(i);}});persist();update();renderReview();listStatus.textContent='List added to your selections. Review quantities before adding to cart. Current prices and stock apply.';});remove.addEventListener('click',()=>{const previous=lists;lists=lists.filter(l=>l.id!==list.id);if(!writeLists()){lists=previous;return;}paintLists();listStatus.textContent='List deleted.';});row.append(title,load,remove);container.append(row);}if(!lists.length)container.textContent='No saved lists yet.';};
listsPanel.querySelector('form').addEventListener('submit',event=>{event.preventDefault();const name=listsPanel.querySelector('input').value.trim();if(!name)return;const items=Object.entries(saved).map(([id,item])=>({id,...item}));if(!items.length){listStatus.textContent='Select at least one frame before saving a list.';return;}if(lists.length>=20){listStatus.textContent='You can save up to 20 lists. Delete an older list to make room.';return;}if(items.length>250){listStatus.textContent='Please keep each list to 250 different frames or fewer.';return;}lists.push({id:Date.now().toString(36)+Math.random().toString(36).slice(2),name,items});if(!writeLists()){lists.pop();return;}paintLists();listStatus.textContent='List saved on this device.';listsPanel.querySelector('form').reset();});
listsButton.addEventListener('click',()=>{renderReview();paintLists();dialog.showModal();});paintLists();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odu-presentation"]) return;
  try {
    
(() => {
  document.addEventListener('input', event => {
    if(!event.target.matches('.odu-filter-search')) return;
    event.stopPropagation();
    const search=event.target, panel=search.closest('.facets__display, .mobile-facets__submenu');
    const query=search.value.trim().toLocaleLowerCase();
    let visible=0;
    panel.querySelectorAll('.facets__item, .mobile-facets__item').forEach(item=>{
      const matches=item.textContent.toLocaleLowerCase().includes(query);
      item.hidden=!matches; if(matches) visible++;
    });
    panel.querySelector('.odu-filter-empty').hidden=visible>0;
  },true);
  const bounds = new Map();
  const watched = new WeakSet();
  const containers = new WeakMap();
  const measure = image => {
    const source = image.currentSrc || image.src;
    if (bounds.has(source)) return bounds.get(source);
    const canvas = document.createElement('canvas');
    const scale = Math.min(1, 320 / Math.max(image.naturalWidth, image.naturalHeight));
    canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
    const context = canvas.getContext('2d', {willReadFrequently:true});
    if (!context) return null;
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const {data} = context.getImageData(0, 0, canvas.width, canvas.height);
    let left=canvas.width, right=-1, top=canvas.height, bottom=-1, edge=0, count=0;
    for(let y=0;y<canvas.height;y++) for(let x=0;x<canvas.width;x++) {
      const i=(y*canvas.width+x)*4;
      if(Math.min(data[i],data[i+1],data[i+2]) < 245) {
        left=Math.min(left,x); right=Math.max(right,x); top=Math.min(top,y); bottom=Math.max(bottom,y); count++;
        if(x<2 || y<2 || x>=canvas.width-2 || y>=canvas.height-2) edge++;
      }
    }
    let result=null;
    if(right>left && bottom>top && edge<8 && count/(canvas.width*canvas.height)<.65 && (right-left)/(bottom-top)>1.1) {
      result={left:Math.max(0,left-3)/canvas.width,right:Math.min(canvas.width,right+4)/canvas.width,top:Math.max(0,top-3)/canvas.height,bottom:Math.min(canvas.height,bottom+4)/canvas.height};
    }
    bounds.set(source,result);
    return result;
  };
  const frame = image => {
    if(!image.complete || !image.naturalWidth) return;
    try {
      const b=measure(image), parent=image.parentElement;
      if(!b || !parent.clientWidth || !parent.clientHeight) return;
      const ratio=image.naturalHeight/image.naturalWidth;
      image.style.setProperty('position','absolute');
      image.style.setProperty('max-width','none','important');
      image.style.setProperty('max-height','none','important');
      const width=Math.min(parent.clientWidth*.86/(b.right-b.left),parent.clientHeight*.78/((b.bottom-b.top)*ratio),parent.clientWidth*2.8);
      const height=width*ratio;
      image.style.setProperty('width',`${width}px`,'important');
      image.style.setProperty('height',`${height}px`,'important');
      image.style.setProperty('left',`${parent.clientWidth/2-width*(b.left+b.right)/2}px`,'important');
      image.style.setProperty('top',`${parent.clientHeight/2-height*(b.top+b.bottom)/2}px`,'important');
      image.dataset.oduFramed='true';
    } catch (_) {}
  };
  const resize = new ResizeObserver(entries => entries.forEach(entry => {
    (containers.get(entry.target)||[]).forEach(frame);
  }));
  const observe = root => root.querySelectorAll('.collection-product-card .media img, .product__modal-opener--image .product__media img, .odu-order-photo img').forEach(image => {
    if(watched.has(image)) return;
    watched.add(image);
    image.addEventListener('load',()=>frame(image));
    const parent=image.parentElement;
    if(!containers.has(parent)){containers.set(parent,[]);resize.observe(parent);}
    containers.get(parent).push(image);
    frame(image);
  });
  observe(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if(node.nodeType===1) observe(node);
  }))).observe(document.body,{childList:true,subtree:true});
})();
(() => {
  const form=document.querySelector('#odu-catalog-form');
  if(!form)return;
  const root=form.closest('.collection-wrapper');
  const toggles=[...root.querySelectorAll('[data-toggle-filters],[data-collapse-filters]')];
  const setVisible=visible=>{root.classList.toggle('odu-filters-hidden',!visible);toggles.forEach(button=>{button.setAttribute('aria-expanded',String(visible));button.textContent=visible?button.dataset.filterHide:button.dataset.filterShow;});};
  toggles.forEach(button=>button.addEventListener('click',()=>setVisible(root.classList.contains('odu-filters-hidden'))));
  setVisible(innerWidth>=990);
  const widthControl=root.querySelector('[data-filter-width]');
  if(widthControl){let width=290;try{width=Number(localStorage.getItem('oduFilterWidth'))||290;}catch(_){}width=Math.max(230,Math.min(420,width));widthControl.value=width;root.style.setProperty('--odu-filter-width',width+'px');widthControl.addEventListener('input',()=>{const next=Math.max(230,Math.min(420,Number(widthControl.value)||290));root.style.setProperty('--odu-filter-width',next+'px');try{localStorage.setItem('oduFilterWidth',String(next));}catch(_){}});}
  form.querySelectorAll('.odu-filter-group').forEach(group=>{const choices=[...group.querySelectorAll('.odu-filter-option input')].filter(input=>!input.disabled||input.checked);if(!choices.length)group.hidden=true;});
  const columnButtons=[...root.querySelectorAll('[data-catalog-columns]')];
  const setColumns=amount=>{const columns=['1','2','3'].includes(String(amount))?String(amount):'1';root.dataset.catalogColumns=columns;columnButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.catalogColumns===columns)));try{localStorage.setItem('oduCatalogColumns',columns);}catch(_){}};
  let savedColumns='1';try{savedColumns=localStorage.getItem('oduCatalogColumns')||'1';}catch(_){}
  setColumns(savedColumns);
  columnButtons.forEach(button=>button.addEventListener('click',()=>setColumns(button.dataset.catalogColumns)));
  form.addEventListener('change',event=>{if(event.target.matches('[data-category-choice]'))event.target.closest('.odu-category-choice').querySelectorAll('[data-category-value]').forEach(input=>input.disabled=!event.target.checked);});
  form.addEventListener('input',event=>{
    if(event.target.matches('.odu-catalog-search')) {
      const query=event.target.value.trim().toLocaleLowerCase();
      event.target.closest('details').querySelectorAll('.odu-filter-option').forEach(label=>label.hidden=!label.textContent.toLocaleLowerCase().includes(query));
    }
    const range=form.querySelector('.odu-price-range');if(!range)return;
    const min=range.querySelector('[data-price-min]'),max=range.querySelector('[data-price-max]'),low=range.querySelector('[data-range-min]'),high=range.querySelector('[data-range-max]');
    if(event.target===low){low.value=Math.min(+low.value,+high.value);min.value=low.value;}
    if(event.target===high){high.value=Math.max(+high.value,+low.value);max.value=high.value;}
    if(event.target===min)low.value=min.value;
    if(event.target===max)high.value=max.value;
    min.setCustomValidity(+min.value>+max.value?'Minimum price must not exceed maximum price.':'');
  });
  root.querySelectorAll('[data-catalog-sort],[data-catalog-pages]').forEach(select=>select.addEventListener('change',()=>form.requestSubmit()));
})();

(()=>{
  const clean=value=>value.replace(/\s*\u2014\s*/g,' ');
  const skip='script,style,noscript,textarea,input,[contenteditable="true"]';
  function tidy(root){
    if(root.nodeType===3){if(root.parentElement&&!root.parentElement.closest(skip)&&root.nodeValue.includes('\u2014'))root.nodeValue=clean(root.nodeValue);return;}
    if(root.nodeType!==1||root.closest(skip))return;
    for(const attr of ['alt','title','aria-label','placeholder']){const value=root.getAttribute(attr);if(value&&value.includes('\u2014'))root.setAttribute(attr,clean(value));}
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;while(node=walker.nextNode())tidy(node);
    root.querySelectorAll('[alt],[title],[aria-label],[placeholder]').forEach(el=>{for(const attr of ['alt','title','aria-label','placeholder']){const value=el.getAttribute(attr);if(value&&value.includes('\u2014'))el.setAttribute(attr,clean(value));}});
  }
  function start(){tidy(document.body);document.title=clean(document.title);new MutationObserver(records=>{for(const record of records){if(record.type==='characterData')tidy(record.target);else record.addedNodes.forEach(tidy);}}).observe(document.body,{childList:true,subtree:true,characterData:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odu-quick-order"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('odu-quick-order')) {
  customElements.define('odu-quick-order', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('form').addEventListener('submit', async event => {
        event.preventDefault();
        if (this.busy) return;
        const inputs = Array.from(this.querySelectorAll('[data-variant]'));
        const items = inputs.filter(input => Number(input.value) > 0).map(input => ({id: input.dataset.variant, quantity: Number(input.value)}));
        const status = this.querySelector('[role="status"]');
        if (!items.length || items.some(item => !Number.isSafeInteger(item.quantity))) {status.textContent = this.dataset.empty; return;}
        const button = this.querySelector('button[type="submit"]');
        this.busy = true;
        button.disabled = true;
        inputs.forEach(input => input.disabled = true);
        status.textContent = this.dataset.busy;
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
          if (!response.ok) {status.textContent = this.dataset.changed; return;}
          inputs.forEach(input => input.value = '0');
          window.location.assign(this.dataset.cartUrl);
        } catch {
          status.textContent = this.dataset.error;
        } finally {
          this.busy = false;
          inputs.forEach(input => {input.value = '0'; input.disabled = false;});
          button.disabled = false;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
